import React from 'react';
import _ from 'lodash';


export const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};
